import { Bell, CalendarRange, FileText, MapPin, MessageCircle, RefreshCw, Users } from "lucide-react";
const EXAMPLES = [["#6366F1", "Clínica: limpeza dental · 6 meses"], ["#06B6D4", "Higienização: caixa d'água · 6 meses"],
  ["#F59E0B", "Oficina: troca de óleo · 6 meses"], ["#10B981", "Contrato mensal · 1 mês"]];

const STEPS = [
  ["1", "Cadastre o serviço feito", "Cliente, tipo de serviço e data. A validade já vem pronta."],
  ["2", "O próximo retorno é calculado", "Você define a periodicidade de cada serviço — dias, semanas, meses ou anos."],
  ["3", "Receba alertas e confirme", "Veja o que vence nos próximos 15 dias e confirme a visita pelo WhatsApp."],
];

const FEATURES = [
  [CalendarRange, "Calendário anual", "Os 12 meses na tela, com uma cor para cada tipo de serviço."],
  [RefreshCw, "Renovação automática", "Marcou como realizado, o próximo agendamento é criado sozinho."],
  [Bell, "Alertas de vencimento", "Serviços vencidos e que vencem em breve sempre à vista."],
  [MapPin, "Rota da semana", "Visitas do dia em ordem, com endereço no Maps e telefone."],
  [MessageCircle, "Lembrete por WhatsApp", "Mensagem pronta com o nome da sua empresa para confirmar a visita."],
  [FileText, "Relatório mensal", "Realizados e agendados do mês, prontos para imprimir."],
  [Users, "Equipe", "Crie logins para seus funcionários usarem os mesmos dados."],
];

export const HowItWorks = () => (
  <section id="como-funciona" className="border-y border-slate-800 bg-slate-950/60 py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">Como funciona</h2>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {STEPS.map(([n, title, text]) => (
          <div key={n} className="rounded-2xl border border-slate-700/60 bg-slate-800/50 p-6" data-testid={`step-${n}`}>
            <span className="font-mono text-sm text-slate-500">0{n}</span>
            <h3 className="mt-3 font-display text-xl font-bold">{title}</h3>
            <p className="mt-2 text-sm text-slate-400">{text}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        {EXAMPLES.map(([hex, label]) => (
          <span key={label} className="flex items-center gap-2 rounded-full border border-slate-700 px-3 py-1.5 text-xs text-slate-300">
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: hex }} /> {label}
          </span>
        ))}
      </div>
    </div>
  </section>
);

export const Features = () => (
  <section id="recursos" className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
    <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">Tudo para não perder nenhuma renovação</h2>
    <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {FEATURES.map(([Icon, title, text]) => (
        <div key={title} className="group rounded-2xl border border-slate-700/60 bg-slate-800/40 p-6 transition-colors duration-200 hover:border-slate-500">
          <Icon className="h-6 w-6 text-slate-300 transition-transform duration-200 group-hover:scale-110" />
          <h3 className="mt-4 font-semibold">{title}</h3>
          <p className="mt-1 text-sm text-slate-400">{text}</p>
        </div>
      ))}
    </div>
  </section>
);
